<template>
  <v-app color="white">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-row align="center" justify="center">
              <v-progress-circular
                :size="45"
                :width="4"
                class="mt-2"
                color="primary"
                indeterminate
                v-if="loading"
              />
              <v-card v-else class="mx-auto" width="400">
                <v-row justify="center">
                  <v-img
                    align="center"
                    justify="center"
                    class="mt-12 mb-6"
                    aspect-ratio="6"
                    contain
                    :src="
                      require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
                    "
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row align="center" justify="center" v-if="isDirty">
                      <v-card class="elevation-0">
                        <v-card-text style="color: red">{{
                          $t("general.login.incorrectEmailAddressOrPassword")
                        }}</v-card-text>
                      </v-card>
                    </v-row>
                  </v-col>
                </v-row>
                <v-form
                  @keydown.native.enter="login"
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      style="margin-bottom: 0px; padding-bottom: 0px"
                    >
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        id="username"
                        :label="$t('general.login.enterEmail')"
                        name="login"
                        :rules="emailRule"
                        type="text"
                        v-model="input.username"
                        required
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      xl="12"
                      style="margin-top: 0px; padding-top: 0px"
                    >
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        id="password"
                        :label="$t('general.login.enterPassword')"
                        name="password"
                        type="password"
                        :rules="passwordlRule"
                        v-model="input.password"
                        required
                      />
                    </v-col>
                  </v-row>
                  <!-- <v-checkbox
                  color="primary"
                  label="Remember me"
                  v-model="input.remember"
                ></v-checkbox> -->
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="8" sm="8" md="8" lg="8" xl="8">
                        <v-btn @click="resetPassword()" color="primary" text>{{
                          $t("general.login.forgotYourPassword")
                        }}</v-btn>
                      </v-col>

                      <v-col cols="4" sm="4" md="4" lg="4" xl="4">
                        <v-btn
                          @click="login"
                          color="primary"
                          class="float-right"
                          text
                          >{{ $t("general.login.login") }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer dark padless v-if="getTheme.name === 'Beneteau' && !loading">
      <v-card class="flex" flat tile color="grey lighten-5">
        <v-card-text class="py-2 grey--text text-center">
          <a
            class="link--color"
            href="https://www.sentinelmarine.net/"
            target="_blank"
          >
            <v-img
              align="center"
              justify="center"
              contain
              class="logo-powered-by-sentinel mx-auto"
              :src="
                require(`@/assets/${this.$store.getters.getLogo.path}/logo-powered-by-sentinel.svg`)
              "
            />
          </a>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { AUTH_REQUEST, AUTH_RESET } from "@/store/actions/auth.js";
import {
  USER_CRM_REQUEST,
  USER_CRM_LICENCE_STATUS_REQUIRED,
} from "@/store/actions/user";
import { mapGetters } from "vuex";
import restrictions from "@/utils/restrictions";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      emailRule: [],
      passwordlRule: [],
      valid: true,
      isDirty: false,
      input: {
        username: "",
        password: "",
        remember: false,
      },
    };
  },
  created() {
    this.setInitialData();
  },

  computed: {
    ...mapGetters([
      "getIframeLoadingStatus",
      "getMe",
      "getTosAccepted",
      "getTosPartnerAccepted",
      "getTheme",
    ]),
  },
  methods: {
    setInitialData() {
      this.emailRule = [
        (v) => !!v || this.$t("general.login.eMailIsRequired"),
        (v) => /.+@.+\..+/.test(v) || this.$t("general.login.eMailMustBeValid"),
      ];
      this.passwordlRule = [
        (v) => !!v || this.$t("general.login.passwordIsRequired"),
      ];
    },
    navigate() {
      if (this.$route.query["next"]) {
        this.$router.pushAsync({
          path: this.$route.query["next"],
        });
      } else {
        const nextRoute = restrictions.nextBaseRoute(this.getMe);
        this.$router
          .pushAsync(nextRoute)
          .then((resp) => {
            this.loading = false;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let { username, password, remember } = this.input;
        username = username.trim();
        this.$store
          .dispatch(AUTH_REQUEST, {
            username,
            password,
          })
          .then((resp) => {
            if (!this.getTosAccepted || !this.getTosPartnerAccepted) {
              return;
            } else {
              this.navigate();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.isDirty = true;
          });
      }
    },
    resetPassword() {
      this.$router.push({
        name: "resetPasswordRequest",
      });
    },
  },
};
</script>
<style scoped>
.link--color {
  color: #9e9e9e;
}

.logo-powered-by-sentinel {
  width: 150px;
  height: 150px;
  filter: saturate(100%) brightness(60%);
  transition: transform 0.3s;
  transition: 0.3s;
}
.logo-powered-by-sentinel:hover {
  filter: saturate(100%) brightness(0%);
  transform: translateY(-10px);
}
</style>
